<template lang="pug">
#collisionDetection.comAll(v-dragDiv,v-show="!actionData.isMini")
  .title.moveDragDiv
    span {{ actionData.cnName }}
    i.el-icon-minus.minibtn(title='最小化' @click='miniCom')
    i.el-icon-close(title='关闭' @click="closeAdd")
  .cd_content
    el-progress.cd-progress-bar( :percentage="progress.percentage", :color="progress.color", :show-text="false", v-show="progress.show" )
    .cd_tab(v-show="comSelectPanelShow")
      .select_left.item
        el-select( v-model="leftModelId", size="mini", placeholder="请选择模型", @change="changeLeftModel" )
          el-option( v-for="model in models", :key="model.id", :label="model.cnName", :value="model.id" )
        .content
          el-tree.model-tree(
            :accordion="true",
            :expand-on-click-node="false",
            :props="props",
            node-key="mgNodeId",
            :load="loadleftNode",
            lazy,:default-expanded-keys="leftExpanded"
            v-slot="{ node, data }",
            :key="leftKey" )
            .labelst(@click.stop="leftClick(data)", :title="data.label") {{ data.label }}
        .selectName {{ leftComponent.label }}
      .select_right.item
        el-select( v-model="rightModelId", size="mini", placeholder="请选择模型", @change="changeRightModel" )
          el-option( v-for="model in models", :key="model.id", :label="model.cnName", :value="model.id" )
        .content
          el-tree.model-tree(
            :accordion="true",
            :expand-on-click-node="false",
            :props="props",
            node-key="mgNodeId",
            :load="loadrightNode",
            lazy,:default-expanded-keys="rightExpanded"
            v-slot="{ node, data }",
            :key="rightKey" )
            .labelst(@click.stop="rightClick(data)", :title="data.label") {{ data.label }}
        .selectName {{ rightComponent.label }}
    .cd_conditions(v-show="comSelectPanelShow")
      el-radio-group(v-model="collisionType")
        el-radio(v-for="(item,index) in collisionTypeOption" :key="item.value" :label="item.value") {{item.name}}
      template(v-if="collisionType === collisionTypeOption[1].value")
        span 距离
        el-input(v-model="softDis" type="number" :min="1" :max="1000" size="mini" )
        span mm
      el-button(size="mini",style="margin-left:auto" @click="comSelectPanelShow = false") 查看结果
      el-button(size="mini",type="primary" @click='calculate' :disabled="!leftComponent.elementId||!rightComponent.elementId") 开始检测
    .cd_result(v-show="!comSelectPanelShow")
      el-table(:data='collisionResult' size="mini" border style='width: 100%' @row-click='handleRowClick')
        el-table-column(label='序号' type='index' width='60')
        el-table-column(prop='element1Name' label='构件1')
        el-table-column(prop='element2Name' label='构件2')
        el-table-column(prop='distance' label='距离' v-if='collisionType === collisionTypeOption[1].value')
      el-pagination(@size-change='handleSizeChange'
        @current-change='handleCurrentChange'
        :current-page='pagination.pageIndex'
        :page-sizes='pagination.pageSizes'
        :page-size='pagination.pageSize'
        :pager-count='5'
        layout='total, sizes, prev, pager, next, jumper'
        :total='pagination.totalCount')
    .cd_conditions(v-show="!comSelectPanelShow")
      el-button(size="mini",style="margin-left:auto" @click="comSelectPanelShow = true") 返回
      el-button(size="mini",type="primary" @click='exportExcel') 导出
    .cd_list
</template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  props: {
    actionData: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      progress: {
        percentage: 0.5,
        show: false,
        color: "#4777e7"
      },
      comSelectPanelShow: true,
      leftModelId: "",
      rightModelId: "",
      leftExpanded: [],
      rightExpanded: [],
      collisionType: '',
      softDis: 3,
      collisionTypeOption: [
        { name: "硬碰撞", value: Monge.CollisionType.INTERSECTION },
        { name: "软碰撞", value: Monge.CollisionType.DISTANCE }
      ],
      props: {
        children: "children",
        label: "label"
      },
      leftKey: 0,
      rightKey: 0,
      leftComponent: {
        elementId: null,
        modelId: null,
        name: null
      },
      rightComponent: {
        elementId: null,
        modelId: null,
        name: null
      },
      collisionResult: [],
      pagination: {
        pageSizes: [20, 50, 100],
        pageIndex: 1,
        pageSize: 20,
        totalCount: 0
      }
    };
  },
  computed: {
    models() {
      return mongeApiMlib.getModels();
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.leftModelId = this.models[0].id;
      this.rightModelId = this.models[0].id;
      this.leftKey++;
      this.rightKey++;
      this.collisionType = this.collisionTypeOption[1].value;
    },
    miniCom() {
      this.$emit("closeCom", "collisionDetection", true);
    },
    closeAdd() {
      this.$emit("closeCom", "collisionDetection", false);
    },
    changeLeftModel() {
      this.leftKey++;
    },
    changeRightModel() {
      this.rightKey++;
    },
    async loadleftNode(node, resolve) {
      if (!this.leftModelId) {
        return;
      }
      const data = await mongeApiMlib.loadOneModelData(node, this.leftModelId);
      if (node.level === 0) {
        this.leftExpanded = [data[0].mgNodeId];
      }
      resolve(data);
    },
    async loadrightNode(node, resolve) {
      if (!this.rightModelId) {
        return;
      }
      const data = await mongeApiMlib.loadOneModelData(node, this.rightModelId);
      if (node.level === 0) {
        this.rightExpanded = [data[0].mgNodeId];
      }
      resolve(data);
    },
    calculate() {
      const data = {
        modelId1: this.leftComponent.modelId,
        modelId2: this.rightComponent.modelId,
        elementId1: this.leftComponent.elementId,
        elementId2: this.leftComponent.elementId
      };
      this.progress.show = true;
      mongeApiMlib.startCalculate(this.collisionType, this.softDis, data, {
        callback: (pre) => {
          this.progress.percentage = pre;
          if (pre == 100) {
            this.progress.show = false;
            this.renderTableData();
          }
        }
      });
    },
    handleRowClick(row) {
      mongeApiMlib.fitToInsert(row.id);
    },
    async renderTableData() {
      const res = await mongeApiMlib.getCollisionData(this.pagination.pageIndex, this.pagination.pageSize);
      this.collisionResult = res.data || [];
      this.pagination.totalCount = res.totalCount;
      this.comSelectPanelShow = false;
    },
    exportExcel() {
      mongeApiMlib.exportExcel();
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.renderTableData();
    },
    handleCurrentChange(val) {
      this.pagination.pageIndex = val;
      this.renderTableData();
    },
    leftClick(data) {
      this.leftComponent = data;
    },
    rightClick(data) {
      this.rightComponent = data;
    }
  }
};
</script>

<style lang="scss" scoped src="@/CommonDP/mongeView/common/common.scss"></style>
<style lang="scss" scoped>
#collisionDetection {
  position: absolute;
  top: 65px;
  left: 151px;
  width: 650px;
  height: calc(100% - 190px);
  max-height: 770px;
  .cd_content {
    width: 100%;
    height: calc(100% - 120px);
    padding: 7px 14px;
    .cd_tab {
      width: 100%;
      height: 100%;
      display: flex;
      flex-direction: row;
      .item {
        width: 50%;
        height: 100%;
        padding: 10px;
        overflow: hidden;
        .content {
          height: calc(100% - 90px);
          margin-top: 10px;
          overflow-y: auto;
          background: rgba(255, 255, 255, 0.98);
        }
        .labelst {
          width: 100%;
        }
        .selectName {
          width: 100%;
          margin-top: 10px;
          height: 40px;
          text-align: center;
          overflow: hidden;
          font-size: 16px;
          line-height: 40px;
          background: rgba(255, 255, 255, 0.98);
          font-weight: 600;
        }
      }
    }
    .cd_result{
      width: 100%;
      height: 100%;
      overflow: hidden;
      display: flex;
      flex-direction: column;
      .el-table{
        width: 100%;
        height: calc(100% - 50px);
        overflow-y: auto;
      }
      .el-pagination{
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
        height: 50px;
      }
    }
    .cd_conditions{
      width: 100%;
      height: 40px ;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 0 14px;
      /deep/.el-radio-group{
        width: 170px;
      }
      /deep/.el-radio{
        margin-right: 10px;
      }
      .el-input{
        width: 120px;
      }
    }
  }
}
</style>
